/* eslint-disable react/jsx-key */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import { Row, Col, Nav, Tab } from 'react-bootstrap';
import Icon from 'components/icon';
import { NavLink, useParams } from 'react-router-dom';

const dinamicRouteTabs = ({ tabs }) => {
  // Ensure tabLinks is an array before calling map
  if (!Array.isArray(tabs)) {
    console.error('tabLinks is not an array', tabLinks);
    return null;
  }
  const { tab } = useParams();
  console.log('🚀 ~ dinamicRouteTabs ~ tab:', tab);
  return (
    <Tab.Container activeKey={tab}>
      <Row>
        <Col sm={12} lg={12}>
          <Nav
            variant="underline"
            className="gap-3 nav-underline flex-nowrap scrollbar w-100 pb-1 mb-3 border-300 border-bottom"
          >
            {tabs.map(item => (
              <Nav.Item key={item.id}>
                <Nav.Link eventKey={item.id} className="text-nowrap">
                  <NavLink to={item.path ? item.path : '#!'}>
                    <Icon icon={item.icon} className="me-2" fontSize="16px" />
                    {item.label}
                    {item.number && (
                      <span className="text-700 fw-normal">
                        ({item.number})
                      </span>
                    )}
                  </NavLink>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          <Tab.Content>
            {tabs.map(item => (
              <Tab.Pane key={item.id} eventKey={item.id}>
                {item.id === tab && item.content}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
};

export default dinamicRouteTabs;
